var React = require('react');

function QuoteQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.0985 74L45.5558 22H14V74H29.0985ZM66.5427 74L83 22H51.4442V74H66.5427Z","fill":"#0000FF"}));
}

QuoteQuote.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = QuoteQuote;

QuoteQuote.default = QuoteQuote;
